exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%; }\n\n.weekContainer, .chartsContainer {\n  display: block;\n  height: 100%;\n  overflow-y: auto;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n\n.chartsContainer {\n  margin-left: 10px; }\n\n.day {\n  font-size: 0.7em;\n  clear: both;\n  overflow: auto;\n  /* left column */\n  background: #F3F3F3;\n  margin-bottom: 10px; }\n  .day .dayTitle {\n    margin-left: 2%;\n    font-size: 1.6em; }\n    .day .dayTitle a, .day .dayTitle a:visited {\n      text-decoration: none;\n      display: inline-block;\n      padding: 5px;\n      color: #7768AE; }\n    .day .dayTitle a:hover, .day .dayTitle a:focus {\n      color: #8F83BC;\n      outline: 1px solid #7768AE;\n      text-decoration: none; }\n    .day .dayTitle a:active {\n      color: #5e4f94; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/vlad/Projects/done/web/src/app/items/ListForWeek.component.sass
// module id = ../../../../../src/app/items/ListForWeek.component.sass
// module chunks = main